const products = [
  {
    name: "Spin Cap for LG Washing Machine",
    id: 101,
    category: "Washing Machine",
    subCategory: "Spin Caps",
    image: require("../assets/images/spinCap.jpg"),
    amazonLink: "https://www.amazon.in/dp/B0DJGYRJHQ",
  },
  {
    name: "Single Door LG Refrigerator Chiller Tray.",
    id: 102,
    category: "Refrigerator",
    subCategory: "Chiller Trays",
    image: require("../assets/images/chillerTray1.jpg"),
    amazonLink: "https://www.amazon.in/dp/B0DJFRYZ3P",
  },
  {
    name: "Capacitor for all Air Conditioner/AC. 50 MFD, Burst Proof.",
    id: 103,
    category: "Air Conditioner",
    subCategory: "Capacitors",
    amazonLink: "https://www.amazon.in/dp/B0F313LDNP",
    image: require("../assets/images/B0F313LDNP.jpg"),
  },
  {
    name: "Fridge Shelf for Single Door Videocon Refrigerator.",
    id: 104,
    category: "Refrigerator",
    subCategory: "Shelves",
    image: require("../assets/images/shelf1.jpg"),
    amazonLink: "https://www.amazon.in/dp/B0DJFLYQJQ",
  },
  {
    name: "Freezer Door for Whirlpool Ice Magic Single Door, 215 ltr to 230 ltr.",
    id: 105,
    category: "Refrigerator",
    subCategory: "Freezer Doors",
    image: require("../assets/images/freezerDoor1.jpg"),
    amazonLink: "https://www.amazon.in/dp/B0F2YVNM9N",
  },
  {
    name: "Vegetable/Fruit Freshner compatible with all refrigerator/Fridge.",
    id: 106,
    category: "Refrigerator",
    subCategory: "Freshners",
    image: require("../assets/images/freshner1.jpg"),
    amazonLink: "https://www.amazon.in/dp/B0F2Z1ZFVX",
  },
  {
    name: "Inlet Pipe for Fully Automatic Machine. 5 Meter",
    id: 107,
    category: "Washing Machine",
    subCategory: "Pipes",
    image: require("../assets/images/pipes1.jpg"),
    amazonLink: "https://www.amazon.in/dp/B0DJDGRPTD",
  },
  {
    name: "Vegetable/Fruit Basket for Whirlpool Single Door Model Duro, 180 ltr.",
    id: 108,
    category: "Refrigerator",
    subCategory: "Vegetable Fruit Basket",
    image: require("../assets/images/basket1.jpg"),
    amazonLink: "https://www.amazon.in/dp/B0F2Z6SJH4",
  },
  {
    name: "fill hose/inlet pipe for all washing machine - 2 Mtr",
    id: 109,
    category: "Washing Machine",
    subCategory: "Pipes",
    image: require("../assets/images/pipes2.jpg"),
    amazonLink: "https://www.amazon.in/dp/B0DLL2YGX1",
  },
  {
    name: "Vegetable/Fruit Basket Cover for Whirlpool Double Door 220 ltr to 250 ltr.",
    id: 110,
    category: "Refrigerator",
    subCategory: "Vegetable Fruit Basket Cover",
    image: require("../assets/images/basketCover1.jpg"),
    amazonLink: "https://www.amazon.in/dp/B0F2X6PLM6",
  },
  {
    name: "Freezer Door for LG refrigerator. 165 ltr to 200 ltr.",
    id: 111,
    category: "Refrigerator",
    subCategory: "Freezer Doors",
    image: require("../assets/images/freezerDoor2.jpg"),
    amazonLink: "https://www.amazon.in/dp/B0DJF438RZ",
  },
  {
    name: "Pulsator Compatible with Old Haier Washing Machine",
    id: 112,
    category: "Washing Machine",
    subCategory: "Pulsators",
    image: require("../assets/images/pulsator1.jpg"),
    amazonLink: "https://www.amazon.in/dp/B0F315QR7J",
  },
  {
    name: "Calstrait Magnetic Water Energiser for Washing Machine",
    id: 113,
    category: "Washing Machine",
    subCategory: "Accessories",
    image: require("../assets/images/accessories1.jpg"),
    amazonLink: "https://www.amazon.in/dp/B0DJHD3LMY",
  },
  {
    name: "Freezer Door for Whirlpool Single Door, 270 ltr to 175 ltr.",
    id: 114,
    category: "Refrigerator",
    subCategory: "Freezer Doors",
    image: require("../assets/images/freezerDoor3.jpg"),
    amazonLink: "https://www.amazon.in/dp/B0F2Z27SLL",
  },
  {
    name: "Vegetable/fruit basket for fridge compatible with Videocon single door 180 ltr.",
    id: 115,
    category: "Refrigerator",
    subCategory: "Vegetable Fruit Basket",
    image: require("../assets/images/basket3.jpg"),
    amazonLink: "https://www.amazon.in/dp/B0DJDS81L2",
  },
  {
    name: "Automatic Voltage stabilizer for All Refrigerator Upto 310 ltr Warranty of 2 Year.",
    id: 116,
    category: "Refrigerator",
    subCategory: "Refrigerator Stabiliser",
    image: require("../assets/images/B0DJFJGBG8.jpg"),
    amazonLink: "https://www.amazon.in/dp/B0DJFJGBG8",
  },
  {
    name: "Capacitor for all Air Conditioner/AC. 50+4 MFD, Burst Proof.",
    id: 117,
    category: "Air Conditioner",
    subCategory: "Capacitors",
    image: require("../assets/images/capacitor1.jpg"),
    amazonLink: "https://www.amazon.in/dp/B0F2ZGNZBH",
  },
  {
    name: "Freezer Door for Whirlpool 180 ltr Duro.",
    id: 118,
    category: "Refrigerator",
    subCategory: "Freezer Doors",
    image: require("../assets/images/freezerDoor4.jpg"),
    amazonLink: "https://www.amazon.in/dp/B0F2WQSP77",
  },
  {
    name: "Freezer Door for Whirlpool Single Door I 190 ltr to 230 ltr I Magic.",
    id: 119,
    category: "Refrigerator",
    subCategory: "Freezer Doors",
    image: require("../assets/images/freezerDoor5.jpg"),
    amazonLink: "https://www.amazon.in/dp/B0F2VV19X9",
  },
  {
    name: "Pulsator Compatible with videocon 6800 Washing Machine. Semi Automatic",
    id: 120,
    category: "Washing Machine",
    subCategory: "Pulsators",
    image: require("../assets/images/B0F3176F3T.jpg"),
    amazonLink: "https://www.amazon.in/dp/B0F3176F3T",
  },
  {
    name: "Pulsator Compatible with LG 1004 Washing Machine",
    id: 121,
    category: "Washing Machine",
    subCategory: "Pulsators",
    image: require("../assets/images/B0F31653S5.jpg"),
    amazonLink: "https://www.amazon.in/dp/B0F31653S5",
  },
  {
    name: "AC stabiliser of 1.5 ton Compatible with Godrej, Whirlpool, Carrier, LG, Samsung, daiken etc. 2 Year Warranty.",
    id: 122,
    category: "Air Conditioner",
    subCategory: "AC Stabilisers",
    image: require("../assets/images/B0F2QTPST4.jpg"),
    amazonLink: "https://www.amazon.in/dp/B0F2QTPST4",
  },
  {
    name: "Chiller Tray for Whirlpool Duro 180 ltr. Single Door.",
    id: 123,
    category: "Refrigerator",
    subCategory: "Chiller Trays",
    image: require("../assets/images/B0F2YWJQ4B.jpg"),
    amazonLink: "https://www.amazon.in/dp/B0F2YWJQ4B",
  },
  {
    name: "Spin Lid Jet Dry Cover Compatible with LG Semi Automatic Washing Machine.",
    id: 124,
    category: "Washing Machine",
    subCategory: "Spin Doors",
    image: require("../assets/images/B0F31J9KF3.jpg"),
    amazonLink: "https://www.amazon.in/dp/B0F31J9KF3",
  },
  {
    name: "Magic Filter Compatible with LG Fully Automatic Washing Machine. Lint Filter/Dust Filter/Waste Collector/Lint Catcher",
    id: 125,
    category: "Washing Machine",
    subCategory: "Filters",
    image: require("../assets/images/B0F2Z4JDLN.jpg"),
    amazonLink: "https://www.amazon.in/dp/B0F2Z4JDLN",
  },
  {
    name: "Refrigerator Bottle Shelf for Whirlpool Single Door Ice Magic.",
    id: 126,
    category: "Refrigerator",
    subCategory: "Bottle Shelfs",
    image: require("../assets/images/B0F2QVXKGQ.jpg"),
    amazonLink: "https://www.amazon.in/dp/B0F2QVXKGQ",
  },
  {
    name: "Heavy Duty Front Load for Fully Automatic Trolly Universal Front & Top Load Washing Machine Stand Trolley/Refrigerator Trolley.",
    id: 127,
    category: "Washing Machine",
    subCategory: "Washing Machine Stands",
    image: require("../assets/images/B0DKDGSLTC.jpg"),
    amazonLink: "https://www.amazon.in/dp/B0DKDGSLTC",
  },
  {
    name: "Bottle Shelf for Single Door Whirlpool I Magic 60mm.",
    id: 128,
    category: "Refrigerator",
    subCategory: "Bottle Shelfs",
    image: require("../assets/images/B0F2WJC4MK.jpg"),
    amazonLink: "https://www.amazon.in/dp/B0F2WJC4MK",
  },
  {
    name: "Capacitor for all Air Conditioner/AC. 25 MFD, Burst Proof.",
    id: 129,
    category: "Air Conditioner",
    subCategory: "Capacitors",
    image: require("../assets/images/B0F314D32H.jpg"),
    amazonLink: "https://www.amazon.in/dp/B0F314D32H",
  },
  {
    name: "Capacitor for all Air Conditioner/AC. 50+6 MFD, Burst Proof",
    id: 130,
    category: "Air Conditioner",
    subCategory: "Capacitors",
    image: require("../assets/images/B0F313KNHL.jpg"),
    amazonLink: "https://www.amazon.in/dp/B0F313KNHL",
  },
  {
    name: "Inlet Pipe for Fully Automatic Washing Machine. 2 Meter",
    id: 131,
    category: "Washing Machine",
    subCategory: "Pipes",
    image: require("../assets/images/B0DJDG8VQM.jpg"),
    amazonLink: "https://www.amazon.in/dp/B0DJDG8VQM",
  },
  {
    name: "Vegetable/Fruit Basket for Whirlpool Double Door 220 ltr to 250 ltr.",
    id: 132,
    category: "Refrigerator",
    subCategory: "Vegetable Fruit Basket",
    image: require("../assets/images/B0F2ZCLTSR.jpg"),
    amazonLink: "https://www.amazon.in/dp/B0F2ZCLTSR",
  },
  {
    name: "Round Ice Cube Tray for Freezer with Lid – Easy Release.",
    id: 133,
    category: "Refrigerator",
    subCategory: "Ice Cube Trays",
    image: require("../assets/images/B0DLQDXKYG.jpg"),
    amazonLink: "https://www.amazon.in/dp/B0DLQDXKYG",
  },
  {
    name: "Washing Machine Cleaner, Descaler for Washing Machine Front load and top load I Washing Machine Cleaning Powder",
    id: 134,
    category: "Washing Machine",
    subCategory: "Washing Machine Others",
    image: require("../assets/images/B0DJHC1JQT.jpg"),
    amazonLink: "https://www.amazon.in/dp/B0DJHC1JQT",
  },
  {
    name: "Chiller Tray for Whirlpool Gen Y from 185 ltr to 230 ltr. Single Door.",
    id: 135,
    category: "Refrigerator",
    subCategory: "Chiller Trays",
    image: require("../assets/images/B0F2YX7T4Q.jpg"),
    amazonLink: "https://www.amazon.in/dp/B0F2YX7T4Q",
  },
  {
    name: "Air Conditioner / AC Stand for 1 Ton, Ton 2, Outdoor Unit Floor Rubber Bracket(4Pc).",
    id: 136,
    category: "Air Conditioner",
    subCategory: "Stands",
    image: require("../assets/images/B0F313LDL6.jpg"),
    amazonLink: "https://www.amazon.in/dp/B0F313LDL6",
  },
  {
    name: "Freezer Door for Whirlpool Single Door, 245 ltr to 305 ltr, Model Gen Y, I Magic.",
    id: 137,
    category: "Refrigerator",
    subCategory: "Freezer Doors",
    image: require("../assets/images/B0F2WQWY4N.jpg"),
    amazonLink: "https://www.amazon.in/dp/B0F2WQWY4N",
  },
  {
    name: "AC Stabiliser 1.5 Ton Compatible with All Brands Samsung, LG, Daiken, Godrej, Whirlpool, Carrier. 2 Year Warranty.",
    id: 138,
    category: "Air Conditioner",
    subCategory: "AC Stabilisers",
    image: require("../assets/images/B0F2QVYGP6.jpg"),
    amazonLink: "https://www.amazon.in/dp/B0F2QVYGP6",
  },
  {
    name: "Anti Vibration pad for Washing Machine I Washing Machine Feet Pad I Anti Vibration and Noise Cancellation Pad(4Pc).",
    id: 139,
    category: "Washing Machine",
    subCategory: "Washing Machine Stands",
    image: require("../assets/images/B0DJHCD2JJ.jpg"),
    amazonLink: "https://www.amazon.in/dp/B0DJHCD2JJ",
  },
  {
    name: "Inlet Pipe for Fully Automatic Washing Machine - 4 Meter",
    id: 140,
    category: "Washing Machine",
    subCategory: "Pipes",
    image: require("../assets/images/B0DJDFYL4F.jpg"),
    amazonLink: "https://www.amazon.in/dp/B0DJDFYL4F",
  },
  {
    name: "Pulsator Needed for Krishna Model Washing Machine 3 Roller",
    id: 141,
    category: "Washing Machine",
    subCategory: "Pulsators",
    image: require("../assets/images/B0F3172PZP.jpg"),
    amazonLink: "https://www.amazon.in/dp/B0F3172PZP",
  },
  {
    name: "Inlet pipe for fully automatic washing machine - 3 meter",
    id: 142,
    category: "Washing Machine",
    subCategory: "Pipes",
    image: require("../assets/images/B0DJDHCS3Z.jpg"),
    amazonLink: "https://www.amazon.in/dp/B0DJDHCS3Z",
  },
  {
    name: "Bottle Shelf for Whirlpool Refrigerator - Mastermind Model.",
    id: 142,
    category: "Refrigerator",
    subCategory: "Bottle Shelfs",
    image: require("../assets/images/B0DJG5VCGC.jpg"),
    amazonLink: "https://www.amazon.in/dp/B0DJG5VCGC",
  },
  {
    name: "Washing Machine Waste Water Drain Pipe. 1.4 Meter with Ratmesh",
    id: 143,
    category: "Washing Machine",
    subCategory: "Pipes",
    image: require("../assets/images/B0DJDPTTLR.jpg"),
    amazonLink: "https://www.amazon.in/dp/B0DJDPTTLR",
  },
  {
    name: "Spin Lid Jet Dry Cover Compatible with Samsung Air TurboSemi Automatic Washing Machine.",
    id: 144,
    category: "Washing Machine",
    subCategory: "Spin Doors",
    image: require("../assets/images/B0F31KKRJ5.jpg"),
    amazonLink: "https://www.amazon.in/dp/B0F31KKRJ5",
  },
  {
    name: "Spin Lid blue cover compatible with Samsun Semi Automatic Washing Machine.",
    id: 145,
    category: "Washing Machine",
    subCategory: "Spin Doors",
    image: require("../assets/images/B0F31LQM99.jpg"),
    amazonLink: "https://www.amazon.in/dp/B0F31LQM99",
  },
  {
    name: "Vegetable/Fruit basket for Samsung Single door 180 ltr.",
    id: 146,
    category: "Refrigerator",
    subCategory: "Vegetable Fruit Basket",
    image: require("../assets/images/B0DJDVXMH4.jpg"),
    amazonLink: "https://www.amazon.in/dp/B0DJDVXMH4",
  },
  {
    name: "Washing Machine & Refrigerator adjustable stand/trolley with wheels compatible with all brands.",
    id: 147,
    category: "Washing Machine",
    subCategory: "Washing Machine Stands",
    image: require("../assets/images/B0DJFHMTZ6.jpg"),
    amazonLink: "https://www.amazon.in/dp/B0DJFHMTZ6",
  },
  {
    name: "Inlet Pipe for Fully Automatic Machine. 5 Meter",
    id: 148,
    category: "Washing Machine",
    subCategory: "Pipes",
    image: require("../assets/images/B0DJDGRPTD.jpg"),
    amazonLink: "https://www.amazon.in/dp/B0DJDGRPTD",
  },
  {
    name: "Vegetable/Fruit Basket for Whirlpool Single Door Model Ice Magic, 190 ltr to 260 ltr.",
    id: 149,
    category: "Refrigerator",
    subCategory: "Vegetable Fruit Basket",
    image: require("../assets/images/B0F2Z7W8DK.jpg"),
    amazonLink: "https://www.amazon.in/dp/B0F2Z7W8DK",
  },
  {
    name: "Vegetable/Fruit Basket Cover for Whirlpool Single Door 185 ltr, I Magic.",
    id: 150,
    category: "Refrigerator",
    subCategory: "Vegetable Fruit Basket Cover",
    image: require("../assets/images/B0F2Z3GDFP.jpg"),
    amazonLink: "https://www.amazon.in/dp/B0F2Z3GDFP",
  },
  {
    name: "Vegetable/Fruit Basket for Whirlpool Single Door 185 ltr I Magic.",
    id: 151,
    category: "Refrigerator",
    subCategory: "Vegetable Fruit Basket",
    image: require("../assets/images/B0F2W5VHMW.jpg"),
    amazonLink: "https://www.amazon.in/dp/B0F2W5VHMW",
  },
  {
    name: "Spin Cap for Videocon Washing Machine",
    id: 152,
    category: "Washing Machine",
    subCategory: "Spin Caps",
    image: require("../assets/images/B0DJGY2LQ8.jpg"),
    amazonLink: "https://www.amazon.in/dp/B0DJGY2LQ8",
  },
  {
    name: "fill hose/inlet pipe for all washing machine - 5 Meter",
    id: 153,
    category: "Washing Machine",
    subCategory: "Pipes",
    image: require("../assets/images/B0DLSJ8W46.jpg"),
    amazonLink: "https://www.amazon.in/dp/B0DLSJ8W46",
  },
  {
    name: "Spin Door for LG Washing Machine Semi Automatic I Wind Jet Dry (Grey)",
    id: 154,
    category: "Washing Machine",
    subCategory: "Spin Doors",
    image: require("../assets/images/B0DJHG6S9H.jpg"),
    amazonLink: "https://www.amazon.in/dp/B0DJHG6S9H",
  },
  {
    name: "Generic White Metal Washing Machine Inlet Pipe, 3 Metres, by Midusa Industries",
    id: 155,
    category: "Washing Machine",
    subCategory: "Pipes",
    image: require("../assets/images/B0DJD7M6NY.jpg"),
    amazonLink: "https://www.amazon.in/dp/B0DJD7M6NY",
  },
  {
    name: "Refrigerator/Fridge top mat Cover with Side Pocket.",
    id: 156,
    category: "Refrigerator",
    subCategory: "Refrigerator Cover",
    image: require("../assets/images/B0F319S39W.jpg"),
    amazonLink: "https://www.amazon.in/dp/B0F319S39W",
  },
  {
    name: "Vegetable/Fruit Basket Cover for Whirlpool Single Door 245 ltr, I Magic, Moisture Control.",
    id: 157,
    category: "Refrigerator",
    subCategory: "Vegetable Fruit Basket Cover",
    image: require("../assets/images/B0F2Z16PXP.jpg"),
    amazonLink: "https://www.amazon.in/dp/B0F2Z16PXP",
  },
  {
    name: "Defrost water tray/compressor Tray for LG single door Refrigerator.",
    id: 158,
    category: "Refrigerator",
    subCategory: "Defrost Trays",
    image: require("../assets/images/B0DJDRNBWD.jpg"),
    amazonLink: "https://www.amazon.in/dp/B0DJDRNBWD",
  },
  {
    name: "Pulsator Compatible with ZEM semi Automatic Washing Machine",
    id: 159,
    category: "Washing Machine",
    subCategory: "Pulsators",
    image: require("../assets/images/B0F3164G9Q.jpg"),
    amazonLink: "https://www.amazon.in/dp/B0F3164G9Q",
  },
  {
    name: "Vegetable/Fruit Basket Cover for Whirlpool Single Door Duro 180 ltr.",
    id: 160,
    category: "Refrigerator",
    subCategory: "Vegetable Fruit Basket Cover",
    image: require("../assets/images/B0F2X27DL9.jpg"),
    amazonLink: "https://www.amazon.in/dp/B0F2X27DL9",
  },
  {
    name: "Vegetable/Fruit Basket for Whirlpool Single Door I Magic, 190 ltr to 230 ltr.",
    id: 161,
    category: "Refrigerator",
    subCategory: "Vegetable Fruit Basket",
    image: require("../assets/images/B0F2Z45K6G.jpg"),
    amazonLink: "https://www.amazon.in/dp/B0F2Z45K6G",
  },
  {
    name: "Automatic Voltage Stabiliser of for All Refrigerator Brand of 450 ltr Warranty - 2 Years.",
    id: 162,
    category: "Refrigerator",
    subCategory: "Refrigerator Stabiliser",
    image: require("../assets/images/B0DJFKNKVN.jpg"),
    amazonLink: "https://www.amazon.in/dp/B0DJFKNKVN",
  },
  {
    name: "Lint Filter Compatible with Whirlpool Semi Automatic Washing Machine. Lint Filter/Dust Filter/Waste Collector/Lint Catcher",
    id: 163,
    category: "Washing Machine",
    subCategory: "Filters",
    image: require("../assets/images/B0F2YZKB25.jpg"),
    amazonLink: "https://www.amazon.in/dp/B0F2YZKB25",
  },
  {
    name: "Pulsator Compatible with Washing Machine 3 Roller. Colour White and Blue",
    id: 164,
    category: "Washing Machine",
    subCategory: "Pulsators",
    image: require("../assets/images/B0F316CYFB.jpg"),
    amazonLink: "https://www.amazon.in/dp/B0F316CYFB",
  },
  {
    name: "Heavy Duty Air Conditioner / AC Outdoor AC Stand for 1 Ton, 1.5 Ton, 2 Ton Outdoor Units Floor AC Stand.",
    id: 165,
    category: "Air Conditioner",
    subCategory: "Stands",
    image: require("../assets/images/B0F315S6F3.jpg"),
    amazonLink: "https://www.amazon.in/dp/B0F315S6F3",
  },
  {
    name: "Bottle shelf for whirlpool Genius single door 180 ltr.",
    id: 166,
    category: "Refrigerator",
    subCategory: "Bottle Shelfs",
    image: require("../assets/images/B0DJG5MV8C.jpg"),
    amazonLink: "https://www.amazon.in/dp/B0DJG5MV8C",
  },
  {
    name: "Automatic Voltage stabiliser Ideal for All Refrigerator (Whirlpool) Upto 400 ltr 2 Year Warranty.",
    id: 167,
    category: "Refrigerator",
    subCategory: "Refrigerator Stabiliser",
    image: require("../assets/images/B0DJFKR3S7.jpg"),
    amazonLink: "https://www.amazon.in/dp/B0DJFKR3S7",
  },
  {
    name: "Pulsator Compatible with Weston Washing Machine.",
    id: 168,
    category: "Washing Machine",
    subCategory: "Pulsators",
    image: require("../assets/images/B0F31BFXKH.jpg"),
    amazonLink: "https://www.amazon.in/dp/B0F31BFXKH",
  },
  {
    name: "Pulsator Compatible with Llyod Semi Automatic Washing Machine. Colour - Grey and Blue",
    id: 169,
    category: "Washing Machine",
    subCategory: "Pulsators",
    image: require("../assets/images/B0F31BFXKH.jpg"),
    amazonLink: "https://www.amazon.in/dp/B0F318LC95",
  },
  {
    name: "Pulsator can be Used with Washing Machine.",
    id: 170,
    category: "Washing Machine",
    subCategory: "Pulsators",
    image: require("../assets/images/B0F31BM7NV.jpg"),
    amazonLink: "https://www.amazon.in/dp/B0F31BM7NV",
  },
  {
    name: "Pulsator Compatible with LG Small Roller Washing Machine. 3 Roller. Colour - Grey",
    id: 171,
    category: "Washing Machine",
    subCategory: "Pulsators",
    image: require("../assets/images/B0F317S36G.jpg"),
    amazonLink: "https://www.amazon.in/dp/B0F317S36G",
  },
  {
    name: "Capacitor for all Air Conditioner/AC. 45+4 MFD, Burst Proof.",
    id: 172,
    category: "Air Conditioner",
    subCategory: "Capacitors",
    image: require("../assets/images/capacitor.jpg"),
    amazonLink: "https://www.amazon.in/dp/B0F2ZF3CRR",
  },
  {
    name: "AC Stand Outdoor I Wall Mount Bracket I Suitable for All AC.",
    id: 173,
    category: "Air Conditioner",
    subCategory: "Stands",
    image: require("../assets/images/B0DJH49KLD.jpg"),
    amazonLink: "https://www.amazon.in/dp/B0DJH49KLD",
  },
  {
    name: "Vegetable/Fruit Basket for Whirlpool Single Door Model I Magic Gen Y, 245 ltr to 305 ltr.",
    id: 174,
    category: "Refrigerator",
    subCategory: "Vegetable Fruit Basket",
    image: require("../assets/images/B0F2Z4868D.jpg"),
    amazonLink: "https://www.amazon.in/dp/B0F2Z4868D",
  },
  {
    name: "Midusa Industries Drain Pipe for Washing Machine, Black, Plastic, 3 Meters, Rat Mesh, Leak-Proof, Universal Compatibility",
    id: 175,
    category: "Washing Machine",
    subCategory: "Pipes",
    image: require("../assets/images/B0DJDRD35L.jpg"),
    amazonLink: "https://www.amazon.in/dp/B0DJDRD35L",
  },
  {
    name: "Chiller Tray for Single Door Samsung Refrigerator.",
    id: 176,
    category: "Refrigerator",
    subCategory: "Chiller Trays",
    image: require("../assets/images/B0DJG4W87N.jpg"),
    amazonLink: "https://www.amazon.in/dp/B0DJG4W87N",
  },
  {
    name: "Spin Cap for Whirlpool Washing Machine",
    id: 177,
    category: "Washing Machine",
    subCategory: "Spin Caps",
    image: require("../assets/images/B0DJGYGYN6.jpg"),
    amazonLink: "https://www.amazon.in/dp/B0DJGYGYN6",
  },
  {
    name: "Universal AC Remote for All Brands Compatible with LG, Godrej, Whirlpool, Haier, Hitachi, Daikin, Sanyo, Carrier, Daewoo, Electrolux, Daikin, Toshiba etc.",
    id: 178,
    category: "Air Conditioner",
    subCategory: "Others",
    image: require("../assets/images/B0DR72VHVQ.jpg"),
    amazonLink: "https://www.amazon.in/dp/B0DR72VHVQ",
  },
  {
    name: "Fully Automatic Washing Machine tap Connector for All Brands. Tap Adaptor for Washing Machine Pipe.",
    id: 179,
    category: "Washing Machine",
    subCategory: "Accessories",
    image: require("../assets/images/B0DJGZC3S3.jpg"),
    amazonLink: "https://www.amazon.in/dp/B0DJGZC3S3",
  },
  {
    name: "Vegetable/Fruit Basket Cover for Whirlpool Single Door Ice Magic 190 ltr to 260 ltr I Moisture Control.",
    id: 180,
    category: "Refrigerator",
    subCategory: "Vegetable Fruit Basket Cover",
    image: require("../assets/images/B0F2XBTBMH.jpg"),
    amazonLink: "https://www.amazon.in/dp/B0F2XBTBMH",
  },
  {
    name: "Spin Cap for Onida Washing Machine",
    id: 181,
    category: "Washing Machine",
    subCategory: "Spin Caps",
    image: require("../assets/images/B0DJGTNWQW.jpg"),
    amazonLink: "https://www.amazon.in/dp/B0DJGTNWQW",
  },
  {
    name: "Vegetable/Fruit Basket for Whirlpool Single Door 310 ltr.",
    id: 182,
    category: "Refrigerator",
    subCategory: "Vegetable Fruit Basket",
    image: require("../assets/images/B0F2Z8P12Y.jpg"),
    amazonLink: "https://www.amazon.in/dp/B0F2Z8P12Y",
  },
  {
    name: "Electric Kettle of 1 Litre, 1350 watt of stainless steel.",
    id: 183,
    category: "Other Appliances",
    subCategory: "Electric Kettles",
    image: require("../assets/images/B0DJZCQZNL.jpg"),
    amazonLink: "https://www.amazon.in/dp/B0DJZCQZNL",
  },
  {
    name: "Vegetable/Fruit Basket Cover for Whirlpool Single Door GenY 190 ltr to 230 ltr I Moisture Control.",
    id: 184,
    category: "Refrigerator",
    subCategory: "Vegetable Fruit Basket Cover",
    image: require("../assets/images/B0F2X2XMRZ.jpg"),
    amazonLink: "https://www.amazon.in/dp/B0F2X2XMRZ",
  },
  {
    name: "Capacitor for all Air Conditioner/AC. 40 MFD, Burst Proof.",
    id: 185,
    category: "Air Conditioner",
    subCategory: "Capacitors",
    image: require("../assets/images/B0F2ZDZX38.jpg"),
    amazonLink: "https://www.amazon.in/dp/B0F2ZDZX38",
  },
  {
    name: "Vegetable/Fruit basket for LG single door 220 ltr to 270 ltr.",
    id: 186,
    category: "Refrigerator",
    subCategory: "Vegetable Fruit Basket",
    image: require("../assets/images/B0DJDCYWRN.jpg"),
    amazonLink: "https://www.amazon.in/dp/B0DJDCYWRN",
  },
  {
    name: "Spin Cap for LG Washing Machine",
    id: 187,
    category: "Washing Machine",
    subCategory: "Spin Caps",
    image: require("../assets/images/B0DJGYRJHQ.jpg"),
    amazonLink: "https://www.amazon.in/dp/B0DJGYRJHQ",
  },
  {
    name: "AC Outdoor Grill Jali for 1.5 Ton for All Brands Size (18 * 18 Inch).",
    id: 188,
    category: "Air Conditioner",
    subCategory: "Others",
    image: require("../assets/images/B0F2QN1M8T.jpg"),
    amazonLink: "https://www.amazon.in/dp/B0F2QN1M8T",
  },
  {
    name: "Vegetable/fruits refrigerator basket for lg single door 165 ltr to 190 ltr.",
    id: 190,
    category: "Refrigerator",
    subCategory: "Vegetable Fruit Basket",
    image: require("../assets/images/B0DJDBS5G2.jpg"),
    amazonLink: "https://www.amazon.in/dp/B0DJDBS5G2",
  },
  {
    name: "Shelf for Single Door Refrigerator.",
    id: 191,
    category: "Refrigerator",
    subCategory: "Shelves",
    image: require("../assets/images/B0DJFRNV7B.jpg"),
    amazonLink: "https://www.amazon.in/dp/B0DJFRNV7B",
  },
  {
    name: "Shelf for Single Door LG Refrigerator.",
    id: 192,
    category: "Refrigerator",
    subCategory: "Shelves",
    image: require("../assets/images/B0DJFNHLQZ.jpg"),
    amazonLink: "https://www.amazon.in/dp/B0DJFNHLQZ",
  },
  {
    name: "Spin Cap for LG Washing Machine (Yellow, Big)",
    id: 193,
    category: "Washing Machine",
    subCategory: "Spin Caps",
    image: require("../assets/images/B0DJGYRJHQ.jpg"),
    amazonLink: "https://www.amazon.in/dp/B0DJGYGXN6",
  },
  {
    name: "Freezer Door for Haier Single Door Fridge of 180 ltr to 200 ltr.",
    id: 194,
    category: "Refrigerator",
    subCategory: "Freezer Doors",
    image: require("../assets/images/B0DJDVZF7F.jpg"),
    amazonLink: "https://www.amazon.in/dp/B0DJDVZF7F",
  },
];
export default products;
